import { crudOperations } from './api';

const documentLibraryService = {
  /**
   * Get all documents (shared + franchisee-specific)
   * @param {string} franchiseeId
   */
  async getDocuments(franchiseeId) {
    try {
      const response = await crudOperations.get(`/document-library/${franchiseeId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching documents:', error);
      throw error;
    }
  },

  /**
   * Upload a document
   * @param {string} franchiseeId
   * @param {FormData} formData - includes file, description, doc_ref, group_name, scope
   */
  async uploadDocument(franchiseeId, formData) {
    try {
      const response = await crudOperations.upload(`/document-library/${franchiseeId}/upload`, formData);
      return response.data;
    } catch (error) {
      console.error('Error uploading document:', error);
      throw error;
    }
  },

  /**
   * Update document metadata
   * @param {string} franchiseeId
   * @param {string} docId
   * @param {object} data - { doc_ref, group_name, description, is_active, sort_order }
   */
  async updateDocument(franchiseeId, docId, data) {
    try {
      const response = await crudOperations.put(`/document-library/${franchiseeId}/${docId}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating document:', error);
      throw error;
    }
  },

  /**
   * Delete a document
   * @param {string} franchiseeId
   * @param {string} docId
   */
  async deleteDocument(franchiseeId, docId) {
    try {
      const response = await crudOperations.delete(`/document-library/${franchiseeId}/${docId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting document:', error);
      throw error;
    }
  }
};

export default documentLibraryService;
